var nextUniqueId = 0;
export function getNextUniqueId() {
  return nextUniqueId++;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/dist/esm/utils/getNextUniqueId.js
// module id = 1845
// module chunks = 0